import { gql } from '@apollo/client';

export const SAVE_PREFERENCES = gql`
  mutation SavePreferences($preferences: VetPreferencesInput!) {
    saveVetPreferences(preferences: $preferences) {
      success
      error {
        __typename
      }
    }
  }
`;
